import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.administrators.add', {
        url: '/add?email',
        component: 'addNewAdministrator',
        resolve: {email},
    });
}

/** @ngInject */
function email($stateParams) {
    return $stateParams.email;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/add/add-new-administrator.state.js